<template>
  <section class="c-carouselcontainer__container">
    <div class="container">
      <div class="c-carouselcontainer__header">
        <h1 class="c-carouselcontainer__header__title">
          {{ $t("Definisci il catalogo premi insieme ai tuoi partner") }}
        </h1>
        <h2 class="c-carouselcontainer__header__subtitle">
          {{
            $t(
              "Stimola l'engagement creando un catalogo composto da prodotti fisici e digitali"
            )
          }}
        </h2>
      </div>
      <swiper
        :options="swiperOption"
        @slideChange="handlePageChange"
        ref="swiper"
      >
        <swiper-slide
          v-if="$mq === 'lg' || $mq === 'md'"
          :class="'c-carouselcontainer__firstslide'"
        >
          <!-- <div class="row ml-2 my-5">
                        <div class="col-10 text-left px-1 animated faster" :class="[this.activePage>0 ? 'fadeOut' : 'fadeIn']">
                            <h2>Utilizza i punti accumulati sulla carta per riscattare fantastici premi.</h2>
                        </div>
                    </div> -->
          <div class="c-carouselcontainer__firstslide__content">
            <h2
              class="animated faster"
              :class="[this.activePage > 0 ? 'fadeOut' : 'fadeIn']"
            >
              {{
                $t(
                  "Stimola l'engagement creando un catalogo composto da prodotti fisici e digitali"
                )
              }}
            </h2>
          </div>
        </swiper-slide>
        <!-- <template v-for="(slide,index) in catalog">
                    <swiper-slide v-bind:key = index>
                        <CarouselBox :image = "slide.image" :title = "slide.title" :cost= "slide.cost" ></CarouselBox>
                    </swiper-slide>
                </template> -->
        <swiper-slide>
          <CarouselBox
            :image="'static/tempAssets/catalog1.jpg'"
            :title="$t('La maglia del tuo campione preferito')"
            :cost="$t('Prodotto Fisico')"
          ></CarouselBox>
        </swiper-slide>
        <swiper-slide>
          <CarouselBox
            :image="'static/tempAssets/catalog2.jpg'"
            :title="$t('Coupon digitali per i tuoi acquisti online')"
            :cost="$t('Coupon digitali')"
          ></CarouselBox>
        </swiper-slide>
        <swiper-slide>
          <CarouselBox
            :image="'static/tempAssets/catalog2.jpg'"
            :title="$t('Incontra il tuo rapper preferito')"
            :cost="$t('Experience')"
          ></CarouselBox>
        </swiper-slide>
      </swiper>
    </div>
  </section>
</template>

<script>
import CarouselBox from "./CarouselBox";

export default {
  props: ["catalog"],
  data() {
    return {
      activePage: 0,
      swiperOption: {
        slidesPerView: 3,
        grabCursor: true,
        watchSlidesProgress: true,
        breakpoints: {
          568: {
            slidesPerView: 1.1,
            spaceBetween: 30
          },
          768: {
            slidesPerView: 1.8,
            spaceBetween: 30
          },
          992: {
            slidesPerView: 1.9,
            spaceBetween: 30
          },
          1200: {
            slidesPerView: 2.3,
            spaceBetween: 30
          }
        }
      }
    };
  },
  components: {
    CarouselBox
  },
  methods: {
    handlePageChange() {
      this.activePage = this.$refs.swiper.swiper.realIndex;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/mixins.scss";

.swiper-container {
  overflow: visible;
  background-color: transparent;
}

.swiper-slide {
  height: auto;
}

.c-carouselcontainer__container {
  padding-bottom: 4rem;
  overflow: hidden;
}

.c-carouselcontainer__header {
  display: flex;
  flex-direction: column;
  text-align: center;
  color: white;
  @include lg {
    max-width: 40%;
    text-align: left;
    color: black;
  }
  @include xl {
    max-width: 40%;
  }
}

.c-carouselcontainer__firstslide__content {
  margin-top: 2rem;
  padding-right: 1rem;
}

.c-carouselcontainer__firstslide {
  display: none;
  @include lg {
    display: block;
  }
}

.c-carouselcontainer__header__subtitle {
  margin-bottom: 2rem;
  @include lg {
    display: none;
  }
}
</style>
